import * as React from "react";

const Close: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="currentColor"><path fill="currentColor" d="M1.534.513 1.023 0 0 1.023l.511.511L3.977 5 .513 8.466 0 8.977 1.023 10l.511-.511L5 6.023l3.466 3.464.511.513L10 8.977l-.511-.511L6.023 5l3.464-3.466.513-.511L8.977 0l-.511.513L5 3.977z"/></svg>;
};

export default React.memo(Close);
